<form class="fix-editor">
  <mat-form-field class="ag-row fix-mat-form">
    <input #alphanumericInput matInput tabindex="0"
           [formControl]="formControl"
           [errorStateMatcher]="matcher"
           [required]="required">
  </mat-form-field>
</form>
